export default __webpack_public_path__ + "static/react_960px-843afee27e7cab19c2350ade9f2d812c.png";